import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromAdminUser from './admin-user.reducer';
import * as AdminUserSelectors from './admin-user.selectors';
import * as AdminUserActions from './admin-user.actions';
import { IOrgUser } from '@care-portals/api-interfaces';

@Injectable()
export class AdminUserFacade {
  loading$ = this.store.pipe(select(AdminUserSelectors.getLoading));
  resetPassModal$ = this.store.pipe(
    select(AdminUserSelectors.getResetPassModal)
  );
  addAdminUser$ = this.store.pipe(select(AdminUserSelectors.getAddAdminUser));

  adminUsers$ = this.store.pipe(select(AdminUserSelectors.getAdminUsers));

  crmUsersEntities$ = this.store.pipe(
    select(AdminUserSelectors.getAdminUsersEntities)
  );

  availableGroups$ = this.store.pipe(
    select(AdminUserSelectors.selectAvailableGroups)
  );

  constructor(private store: Store<fromAdminUser.AdminPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  getAdminUsers(
    query?: { name?: string; role?: string },
    ignoreCache?: boolean
  ) {
    this.dispatch(AdminUserActions.getAdminUsers({ query, ignoreCache }));
  }
  createAdminUser(adminUser: IOrgUser) {
    this.dispatch(AdminUserActions.createAdminUser({ adminUser }));
  }
  startAddAdminUser() {
    this.dispatch(AdminUserActions.startAddAdminUser());
  }
  cancelAddAdminUser() {
    this.dispatch(AdminUserActions.cancelAddAdminUser());
  }
  updateAdminUser(adminUser: IOrgUser) {
    this.dispatch(AdminUserActions.updateAdminUser({ adminUser }));
  }
  startEditAdminUser(adminUserId: string) {
    this.dispatch(AdminUserActions.startEditAdminUser({ adminUserId }));
  }
  cancelEditAdminUser(adminUserId: string) {
    this.dispatch(AdminUserActions.cancelEditAdminUser({ adminUserId }));
  }
  deleteAdminUser(adminUserId: string) {
    this.dispatch(AdminUserActions.deleteAdminUser({ adminUserId }));
  }
  resetAdminUserPassword(adminUserId: string) {
    this.dispatch(AdminUserActions.resetAdminUserPassword({ adminUserId }));
  }
  openResetAdminUserPasswordModal() {
    this.dispatch(AdminUserActions.openResetAdminUserPasswordModal());
  }
  closeResetAdminUserPasswordModal() {
    this.dispatch(AdminUserActions.closeResetAdminUserPasswordModal());
  }
}
